import { type TypographyCommon, type Variant } from './types'
import { BaseTypography } from './BaseTypography'

type Props = TypographyCommon<{
  /**
   * Set your color
   * @default 'Bold'
   */
  variant?: Variant<'primary' | 'dhlRed' | 'goGreen' | 'inherit'>
}>

/**
 * Demos:
 * - [H3](https://design-system.accept.cl1.intra.dhlparcel.io/?path=/story/primitives-typography--h-3)
 *
 */

export const H3 = ({ children, variant = 'primary', ...rest }: Props) => (
  <BaseTypography variant="h3" color={variant} {...rest}>
    {children}
  </BaseTypography>
)
